export default __webpack_public_path__ + "static/bottom-4-4ef3593a1f81e9d1c3df8c24e4423c31.png";